import { UserManager } from "./../../Services/UserManager/user-manager";
import { Subscription } from "rxjs/Subscription";
import {
  Component,
  OnInit,
  ViewChildren,
  QueryList,
  HostListener,
  OnDestroy,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AngularFireDatabase } from "@angular/fire/database";
import { Question } from "../../Models/question.interface";
import { LessonManagerService } from "../../Services/LessonManager/lesson-manager.service";
import { LessonCard } from "../../Models/lessons.interface";
import { QuestionTemplateComponent } from "../../templates/question-template/question-template.component";
import { GlobalVariablesService } from "../../Services/globalVariables/global-variables.service";
import { Location } from "@angular/common";
import { ScrollService } from "../../Services/ScrollManager/scroll.service";
import {
  trigger,
  state,
  style,
  transition,
  animate,
  keyframes,
} from "@angular/animations";
import { Subject } from "rxjs";
import { Title } from "@angular/platform-browser";
import { LanguageSwitchService } from "../../Services/LanguageSwitch/language-switch.service";
export enum KEY_CODE {
  RIGHT_ARROW = 39,
  LEFT_ARROW = 37,
}

@Component({
  selector: "app-lesson-template",
  templateUrl: "./lesson-template.component.html",
  styleUrls: ["./lesson-template.component.css", "./svg.scss"],
  animations: [
    trigger("trigger", [
      state(
        "show",
        style({
          opacity: 1,
        })
      ),
      state(
        "void",
        style({
          opacity: 0,
        })
      ),
      transition("void => show", animate("400ms 500ms ease-in-out")),
      transition("show => void", animate("400ms 500ms ease-in-out")),
    ]),
    trigger("shake", [
      state(
        "void",
        style({
          transform: "scale(1.0)",
          backgroundColor: "*",
          border: "*",
          color: "*",
        })
      ),
      state(
        "pulsing",
        style({
          transform: "scale(1.1)",
          backgroundColor: "white",
          border: "3px solid #E09A00",
          color: "#E09A00",
        })
      ),
      transition("* => void", [animate("300ms ease-in-out")]),
      transition("void => pulsing", [animate("500ms ease-in-out")]),
    ]),
  ],
})
export class LessonTemplateComponent implements OnInit, OnDestroy {
  config;
  title: string;
  img: string;
  viewChecked = false;
  lessonCard: LessonCard;
  lessonID: string;
  questionID: string;
  currentQuestionID: number = 1;
  currentQuestionCorrect: boolean = false;
  questions: Array<Question>;
  questionsSubscription: Subscription;
  currentState = "void";
  readyToContinue = "void";

  allQuestionCorrectCount: number = 0;
  allQuestionCorrect: boolean = false;
  hasNextQuestion: boolean = true;
  hasPreviousQuestion: boolean = false;
  incomplete = {};
  firstIncomplete: number;
  leaving = new Subject();
  @ViewChildren(QuestionTemplateComponent)
  questionElements: QueryList<QuestionTemplateComponent>;
  loaded = false;
  stateArray = Array<string>();
  rtreturn;

  constructor(
    private route: ActivatedRoute,
    private um: UserManager,
    private lm: LessonManagerService,
    private db: AngularFireDatabase,
    private gv: GlobalVariablesService,
    private titleService: Title,
    private scroll: ScrollService,
    private ls: LanguageSwitchService
  ) {
    this.ls.config.subscribe({
      next: (config) => {
        this.config = config;
      },
    });
  }

  ngOnInit() {
    const id = +this.route.snapshot.paramMap.get("id");
    this.lessonID = this.route.snapshot.paramMap.get("id");
    const lessonCard = this.lm.getCard(id);
    this.lessonCard = lessonCard;
    this.titleService.setTitle(`Guide ${this.lessonCard.id}`);
    this.db
      .list<Question>(`${this.config.questionsRoot}/${lessonCard.id}`, (ref) =>
        ref.orderByChild("questionID")
      )
      .valueChanges()
      .takeUntil(this.leaving)
      .subscribe((questions) => {
        this.questions = questions;
        questions.forEach((q) => this.stateArray.push("hideRight"));
        this.gv.print(questions.length);
        this.scrollToQuestion();
      });
    this.currentState = "show";

    let referrer = localStorage.getItem("rte-referrer");
    if (referrer) {
      this.rtreturn = referrer;
    }
  }

  markIncomplete(lessonNumber: number) {
    this.readyToContinue = "void";
    this.incomplete[`${lessonNumber}`] = lessonNumber;

    this.updateFirstIncomplete();
    this.checkIfAllCorrect();
  }

  markComplete(lessonNumber: number) {
    // highlight button here\
    this.readyToContinue = "pulsing";

    if (this.incomplete[`${lessonNumber}`]) {
      delete this.incomplete[`${lessonNumber}`];
    }
    this.checkIfAllCorrect();
    this.updateFirstIncomplete();
  }

  updateFirstIncomplete() {
    const keys = Object.keys(this.incomplete);
    if (keys.length > 0) {
      const lessonToGoTo = this.incomplete[`${keys[0]}`];
      this.firstIncomplete = +lessonToGoTo;
    }
  }

  ngOnDestroy() {
    this.deactivate(+this.currentQuestionID);
    this.leaving.next();
  }

  @HostListener("window:keyup", ["$event"])
  keyEvent(event: KeyboardEvent) {
    // console.log(event);

    if (event.keyCode === KEY_CODE.RIGHT_ARROW) {
      if (this.hasNextQuestion) {
        this.goForward();
      }
      if (this.allQuestionCorrect && !this.hasNextQuestion) {
        this.gotoNextLesson();
      }
    }

    if (event.keyCode === KEY_CODE.LEFT_ARROW) {
      if (this.hasPreviousQuestion) {
        this.goBack();
      }
    }
  }

  ngAfterViewInit() {
    this.um
      .checkLessonUnlocked(+this.lessonID)
      .then((unlocked) => {
        if (!unlocked) {
          this.um.gotoMyLessons();
        }
      })
      .catch((e) => console.error(e, "No Access to Lesson"));

    setTimeout(() => {
      this.questionElements.changes
        .takeUntil(this.leaving)
        .subscribe((change) => {
          if (!!this.questionElements && !!this.questions) {
            let questionID = this.um.getCurrentQuestion(this.lessonCard.id);
            if (!!questionID) {
              this.updateNextAndPrevious(+questionID);
              if (
                this.questionElements.length + 1 === this.questions.length &&
                !this.loaded
              ) {
                this.loaded = true;
                this.currentQuestionID = +questionID;
                change.forEach((question) => {
                  if (+this.currentQuestionID != question.questionID) {
                    this.toggleOnOff(question.questionID);
                  }
                  if (+this.currentQuestionID === +question.questionID) {
                    this.activate(question.questionID);
                    this.currentQuestionCorrect = question.allCorrect;
                    this.checkIfAllCorrect();
                    this.unhide();
                  }
                });
              }
            }
          }
        });
    });
  }

  count = 0;
  cycle(): number {
    this.count += 1;
    return this.count;
  }

  unhide() {
    try {
      this.currentQuestionID = +this.um.getCurrentQuestion(this.lessonCard.id);
      if (this.currentQuestionID) {
        const currentQuestionID = this.questionElements.find((question) => {
          return +this.currentQuestionID === +question.questionID;
        });
        if (currentQuestionID) {
          currentQuestionID.activate().then(() => {
            document
              .getElementById(`${this.currentQuestionID}`)
              .classList.remove("hide");
          });
        }
      }
    } catch (e) {
      document
        .getElementById(`${this.currentQuestionID}`)
        .classList.remove("hide");
    }
  }

  scrollToQuestion() {
    this.scroll.scrollToElement(`#dots`);
  }

  isCorrect(questionID: number) {
    let q = this.questionElements.find((question) => {
      return questionID === +question.questionID;
    });
    if (q) {
      return q.allCorrect;
    } else {
      return false;
    }
  }

  toggleOnOff(questionID: number) {
    const aQuestion = this.questionElements.find((question) => {
      return questionID === +question.questionID;
    });

    if (aQuestion) {
      aQuestion.toggleOnOff();
    }
  }

  activate(questionID: number, direction?: string) {
    const nextQuestion = this.questionElements.find((question) => {
      return questionID === +question.questionID;
    });
    if (nextQuestion) {
      nextQuestion
        .activate(direction)
        .then(() =>
          document.getElementById(`${questionID}`).classList.remove("hide")
        );
    }
  }

  deactivate(questionID: number, direction?: string) {
    const nextQuestion = this.questionElements.find((question) => {
      return questionID === +question.questionID;
    });
    if (nextQuestion) {
      nextQuestion.deactivate(direction);
    }
  }

  updateCurrentQuestion(questionID: number) {
    document.getElementById(`${this.currentQuestionID}`).classList.add("hide");
    this.currentQuestionID = +questionID;
    const newCurrentQuestion = this.questionElements.find((question) => {
      return questionID === +question.questionID;
    });

    if (newCurrentQuestion) {
      this.currentQuestionCorrect = newCurrentQuestion.allCorrect;
    }

    this.um.saveCurrentQuestion(+this.lessonCard.id, +this.currentQuestionID);
    this.updateNextAndPrevious(+this.currentQuestionID);
  }

  updateNextAndPrevious(questionID: number) {
    if (!this.questionElements) {
      return;
    }
    const nextQuestion = this.questionElements.find((question) => {
      return questionID + 1 === +question.questionID;
    });
    const previousQuestion = this.questionElements.find((question) => {
      return questionID - 1 === +question.questionID && questionID - 1 !== 0;
    });

    this.hasNextQuestion = nextQuestion ? true : false;
    this.hasPreviousQuestion = previousQuestion ? true : false;
  }

  checkIfAllCorrect() {
    this.allQuestionCorrectCount = 0;
    this.allQuestionCorrect = false;
    this.questionElements.forEach((question) => {
      if (question?.allCorrect) {
        this.allQuestionCorrectCount += 1;
        if (this.allQuestionCorrectCount === this.questions.length - 1) {
          this.allQuestionCorrect = true;
          this.um.unlockLesson(+this.lessonID + 1);
        }
      }
    });
  }

  back() {
    this.activate(+this.currentQuestionID - 1, "hideLeft");
    this.deactivate(+this.currentQuestionID, "hideRight");
    this.backFinished();
  }

  backFinished() {
    document.getElementById(`${this.currentQuestionID}`).classList.add("hide");
    this.updateCurrentQuestion(+this.currentQuestionID - 1);
  }

  forward() {
    this.activate(+this.currentQuestionID + 1, "hideRight");
    this.deactivate(+this.currentQuestionID, "hideLeft");
    this.forwardFinished();
  }

  forwardFinished() {
    document.getElementById(`${this.currentQuestionID}`).classList.add("hide");
    this.updateCurrentQuestion(+this.currentQuestionID + 1);
  }

  hit = false;
  goBack() {
    if (this.hit) {
      return;
    }
    if (+this.currentQuestionID <= 1) {
      // do nothing.  you're on question one
      return;
    } else {
      document
        .getElementById(`${+this.currentQuestionID - 1}`)
        .classList.remove("hide");
      this.back();
    }
  }

  goForward() {
    //reset our button
    this.readyToContinue = "void";
    if (this.hit) {
      return;
    }
    if (+this.currentQuestionID >= this.questions.length - 1) {
      return;
    } else {
      document
        .getElementById(`${+this.currentQuestionID + 1}`)
        .classList.remove("hide");
      this.forward();
    }
  }

  waitForHit() {
    this.hit = true;
    setTimeout(() => {
      this.hit = false;
    }, 1000);
  }

  goto(questionID: number) {
    if (+this.currentQuestionID === questionID) {
      return;
    } else if (+this.currentQuestionID > questionID) {
      this.activate(questionID, "hideLeft");
      this.deactivate(+this.currentQuestionID, "hideRight");
      document
        .getElementById(`${this.currentQuestionID}`)
        .classList.add("hide");
      document.getElementById(`${questionID}`).classList.remove("hide");
    } else {
      this.activate(questionID, "hideRight");
      this.deactivate(+this.currentQuestionID, "hideLeft");
      document
        .getElementById(`${this.currentQuestionID}`)
        .classList.add("hide");
      document.getElementById(`${questionID}`).classList.remove("hide");
    }
    this.updateCurrentQuestion(questionID);
  }

  gotoNextLesson() {
    this.um.gotoLessonHeader(+this.lessonID + 1);
  }

  gotoLastUnansweredQuestion() {
    const keys = Object.keys(this.incomplete);
    if (keys.length > 0) {
      const lessonToGoTo = this.incomplete[`${keys[0]}`];
      this.goto(lessonToGoTo);
    }
  }

  finishCourse() {
    if (this.rtreturn) {
      localStorage.removeItem("rte-referrer");
      window.location.href = this.rtreturn;
    } else {
      this.um.finishCourse();
    }
  }
}
